import { useMutation, useQueryClient } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import meKeys from '@/api/queries/me/keyFactory';
import { graphql } from '@/gql';

const RegenerateCalendarFeedTokenMutation = graphql(`
  mutation RegenerateCalendarFeedToken {
    regenerateCalendarFeedToken {
      url
      webcalUrl
    }
  }
`);

export const useRegenerateCalendarFeedToken = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => gqlClient.request(RegenerateCalendarFeedTokenMutation),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: meKeys.calendarFeed() });
    },
  });
};

export default useRegenerateCalendarFeedToken;
